"use client";
import React from "react";

type LoadingOverlayProps = {
  label?: string;
  visible?: boolean; // keep mounted, toggle when needed
};

export default function LoadingOverlay({label = "Loading", visible = true}: LoadingOverlayProps) {
  if (!visible) return null;

  return (
    <div role="status" aria-live="polite" className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/80 backdrop-blur-sm text-white">
      <h2 className="loading-text text-xl md:text-2xl font-semibold">{label}</h2>
    </div>
  );
}
